import { hash } from '@ember/helper';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsMlpProductFeedComponent extends Component {
  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1'>
          <form.fieldset @titleKey='elements' as |fieldset|>
            <fieldset.field @property='headline' />
            <fieldset.field
              @property='artist'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />
            <fieldset.field
              @property='channel'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />
            <fieldset.field
              @property='categories'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field @property='limit' @type='number' />

            <fieldset.field
              @property='taxa'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
